import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "_helpers";
// create slice = combination of reducer and action

const name = "invoice";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });
//each slice have 3 elements first is name second is state, then reducer

// exports

export const invoiceActions = { ...slice.actions, ...extraActions };
export const invoiceReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    invoiceDetails: [],
    createInvoiceRes: [],
    uploads: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}/invoice`;

  return {
    createInvoice: createInvoice(),
    getInvoiceList: getInvoiceList(),
    uploadInvoice: uploadInvoice(),
    createMultipleInvoice: createMultipleInvoice()
  };
  function createInvoice() {
    return createAsyncThunk(`${name}/create`, async (data) => {
      await fetchWrapper.post(`${baseUrl}/create`, 
        data
      , 'multipart');
    });
  }
  function getInvoiceList() {
    return createAsyncThunk(
      `${name}/getById`,
      async (id) => await fetchWrapper.get(`${baseUrl}/${id}`)
    );
  }
  function uploadInvoice() {
    return createAsyncThunk(`${name}/upload`, async ({files, pos, messages}) => {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append(`files`, file);
      });
      const response = await fetchWrapper.post(`${baseUrl}/uploadMultipleInvoices`, formData, 'multipart');
      console.log('uuuuuu',response, pos);
      try {
      const invoices = pos.map((po, index) => {
        const obj = {};
        obj.poNumber = po.po_number;
        obj.pohScheduleId = po.id;
        obj.documentName = response.data[index].name;
        obj.uniqueDocumentName = response.data[index].uniqueName;
        obj.remarks = messages[index]
          ? messages[index].text.map((msg) => msg.text)
          : [];
        return obj;
      });
      const createResponse = await fetchWrapper.post(`${baseUrl}/createMultipleInvoices`, {"invoices":invoices});
      return createResponse.data;
    } catch (error) {
      console.log(error);
    }
    });
  }
  function createMultipleInvoice() {
    return createAsyncThunk(`${name}/createMultipleInvoices`, async (data) => {
      console.log(data);
      const response = await fetchWrapper.post(`${baseUrl}/createMultipleInvoices`, data);
      return response.data;
    });
  }
}
function createExtraReducers() {
  return (builder) => {
    createInvoice();
    getInvoiceList();
    uploadInvoice();
    createMultipleInvoice();
    function createInvoice() {
      var { pending, fulfilled, rejected } = extraActions.createInvoice;
      builder
        .addCase(pending, (state) => {
          state.createInvoiceRes = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.createInvoiceRes = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.createInvoiceRes = { error: action.error };
        });
    }
    function getInvoiceList() {
      var { pending, fulfilled, rejected } = extraActions.getInvoiceList;
      builder
        .addCase(pending, (state) => {
          state.invoiceDetails = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.invoiceDetails = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.invoiceDetails = { error: action.error };
        });
    }
    function uploadInvoice() {
      var { pending, fulfilled, rejected } = extraActions.uploadInvoice;
      builder
        .addCase(pending, (state) => {
          state.uploads = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.uploads = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.uploads = { error: action.error };
        });
    }
    function createMultipleInvoice(){
      var { pending, fulfilled, rejected } = extraActions.createMultipleInvoice;
      builder
        .addCase(pending, (state) => {
          state.createInvoiceRes = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.createInvoiceRes = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.createInvoiceRes = { error: action.error };
        });
    }
  };
}
